'use client';

import { AD_PLACEMENTS } from './adPlacements';
import { NativeAdSlot } from './NativeAdSlot';

export const PolicyGuideTopAdBanner = () => (
  <NativeAdSlot {...AD_PLACEMENTS.policyGuideTop} />
);
